import React, { useState, useContext } from 'react'

import LoadingButton from '@mui/lab/LoadingButton'

import Templates from '../../Templates'

import AddIcon from '@mui/icons-material/Add'

import SelectChannel from './SelectChannel'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email'
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';

import { ScreenContext } from '../..'
import SendSMS from './SendSMS'
import SendEmail from './SendEmail'
import SendScout from './SendScout'

import CreateCampaignModal from "../../CreateCampaignModal"

import { getSession } from "../../../../auth"

const channels = (props) => {
    return {
        'whatsapp': {
            icon: (<><WhatsAppIcon className="conversationItemIcon whatsAppIcon" /></>),
            component: (<Templates
                open={true}
                templates={props.templates}
                queues={props.queues}
                clients={props.clients}
                selectionIds={props.selectedModel}
                originNumbers={props.originNumbers}
                handleClose={() => { props.setSelectedChannel(); props.setShowSelect() }}
                handlePostSuccess={props.submit}
                selectedNumberModel={props.selectedNumberModel}

            />)
        },
        'sms': {
            icon: (<><SmsIcon className="conversationItemIcon" sx={{ color: '#757575' }} /></>),
            component: (<>
                <SendSMS
                    queues={props.queues}
                    selectedNumberModel={props.selectedNumberModel}
                    handleClose={() => { props.setSelectedChannel(); props.setShowSelect() }}
                />
            </>)
        },
        'email': {
            icon: (<><EmailIcon className="conversationItemIcon" sx={{ color: '#757575' }} /></>),
            component: (<>
                <SendEmail
                    queues={props.queues}
                    clients={props.selectedModel}
                    handleClose={() => { props.setSelectedChannel(); props.setShowSelect() }}
                />
            </>)
        },
        'scout': {
            icon: (<><ImportantDevicesIcon className="conversationItemIcon" sx={{ color: '#757575' }} /></>),
            component: (<>
                <SendScout
                    handleClose={() => { props.setSelectedChannel(); props.setShowSelect() }}
                    contacts={props.selectedModel}
                />
            </>)

        }
    }
}

const SendMessage = () => {
    const {
        originNumbers,
        clients,
        queues,
        templates,
        selectedModel,
        selectedNumberModel,
        updateNumberSelectedModel,
        updateReady
    } = useContext(ScreenContext)

    const [showSelect, setShowSelect] = useState(false)

    const [selectedChannel, setSelectedChannel] = useState()

    const submit = async () => {
        updateReady(false)
        updateNumberSelectedModel([])
        updateReady(true)
    }

    const loadChannels = channels({
        templates, queues, clients, selectedModel, originNumbers, setSelectedChannel, submit, selectedNumberModel, setShowSelect
    })

    return (
        <>
            {showSelect && 
                <CreateCampaignModal open={showSelect}
                    title="Nova campanha com contatos selecionados"
                    buttonText="Adicionar"
                    queues={queues}
                    senders={originNumbers}
                    templates={templates}
                    enterpriseId={getSession().profile.enterprise.id}
                    handleClose={() => {}}
                    submit={() => setShowSelect(false)}
                    selectedContacts={selectedModel}
                    contactType="selected"
                />
            }
            {selectedChannel && loadChannels[selectedChannel]?.component}
            <LoadingButton
                className="button-notify nomargin"
                onClick={() => { setShowSelect(true) }}
                variant={"contained"}
                color="warning"
                disabled={selectedModel.length === 0}
                startIcon={<AddIcon />}
                sx={{ marginBottom: "0 !important" }}
            >
                Nova campanha
            </LoadingButton>
        </>
    )
}

export default SendMessage
